import {AfterViewInit, ChangeDetectorRef, Component, TemplateRef, ViewChild} from '@angular/core';
import {SpecialCompbaser} from "../../../components/compbaser";
import {ExperienceLevelType, IOrderDetails, IOrderForm, IUser} from "../../../interfaces";
import {SimpleListComponent} from "../../../components/simple-list/simple-list.component";
import {actionLoadOrderRequest, actionLoadOrdersRequest} from "../../../store/actions/user.actions";
import {basicTransition} from "../../../../libs/basicTransition";
import {AppService, LocalStoreService, StoreSelectorsService} from "../../../services";
import {ActivatedRoute, Router} from "@angular/router";
import {MatTabGroup} from "@angular/material/tabs";
import {Memoizee} from "../../../decorators/memoizee-decorator";
import {MatDialog} from "@angular/material/dialog";
import {isHostDevOrLocal} from "../../../common";
import {FintechService} from "../../../services/fintech.service";
import {filter, tap} from "rxjs/operators";

@Component({
    selector: 'app-account-details',
    templateUrl: './account-details.component.html',
    styleUrls: ['./account-details.component.scss'],
    animations: [basicTransition]
})
export class AccountDetailsComponent extends SpecialCompbaser implements AfterViewInit {

    ORDERS_TAB = 1;
    avatarSrc: string | undefined;
    avatarFile: File | undefined;
    uploaded = false;
    enterpriseMode: boolean;
    dashboardMode: boolean;
    avatarTooSmall = false;
    avatarTooLarge = false;
    orderList: Array<IOrderForm>;
    order: IOrderDetails;
    user: IUser;
    autoLoadOrderNumber;
    useAvatar = 0;
    ready;
    devMode = false;
    mouseDown = false;
    m_businessUserName = '';
    activeTabIndex = 0;

    readonly experienceLevelType = ExperienceLevelType; // Expose enum to template
    experienceLevel: ExperienceLevelType;

    @ViewChild("revealPassword", {read: TemplateRef}) revealPassword: TemplateRef<any>;

    @ViewChild('simplelist')
    simplelist: SimpleListComponent;

    @ViewChild("tabGroup", {static: false})
    tabGroup: MatTabGroup;

    constructor(private appService: AppService,
                private storeSelector: StoreSelectorsService,
                public override dialog: MatDialog,
                private route: ActivatedRoute,
                private router: Router,
                private localStoreService: LocalStoreService,
                public fintechService: FintechService,
                private cdr: ChangeDetectorRef) {
        super(dialog);
        this.storeSelector.dispatch(actionLoadOrdersRequest({}));
        this.appService.syncUser();
        this.devMode = isHostDevOrLocal();
        this.setMe('account-details.component.ts');
        this.cod(
            this.storeSelector.getOrders().subscribe((orders) => {
                if (Array.isArray(orders) && orders.length === 1 && typeof orders[0] === 'object' && orders[0] !== null && Object.keys(orders[0]).length === 0) {
                    this.orderList = [];
                    this.ready = true;
                    return;
                }
                this.orderList = orders;
                this.ready = true;
            })
        );
        this.cod(
            this.storeSelector.getLocalStoreUpdates()
                .subscribe((updates) => {
                    this.useAvatar = this.localStoreService.getStorageValConfig('useAvatar');
                })
        );
        this.cod(
            this.route.paramMap.subscribe((routeParams) => {
                this.autoLoadOrderNumber = routeParams.get('order_id');
                // this.localStoreService.removeCartStorage();
            })
        );

        // Query params will be handled in ngAfterViewInit to ensure tabGroup is ready
        this.cod(
            storeSelector.getUser()
                .subscribe((user: IUser) => {
                    this.user = user;
                    this.enterpriseMode = user.enterprise;
                    this.dashboardMode = user.dashboard;
                    // if (this.dashboardMode) {
                    //     this.accountDetailsMode = "ACCOUNT_MANAGER";
                    // } else if (!this.enterpriseMode) {
                    //     this.accountDetailsMode = "SUBSCRIBE_TO";
                    // } else {
                    //     this.accountDetailsMode = "SUBSCRIBE_MANAGE";
                    // }
                })
        );
        this.cod(
            this.storeSelector.getOrder().subscribe((order) => {
                this.order = order;
            })
        );
        // this.initForm();


        const obs$ = this.fintechService.getFintechInfo();
        this.cod(obs$.subscribe());


        this.experienceLevel = this.localStoreService.getStorageValConfig('experienceLevel'); // Alon
        this.cod(
            this.storeSelector.getLocalStoreUpdates('ILocalStorageConfig').subscribe((e) => {
                this.experienceLevel = this.localStoreService.getStorageValConfig('experienceLevel'); // Alon
            })
        );
    }

    ngAfterViewInit() {
        if (this.autoLoadOrderNumber) {
            setTimeout(() => {
                this.tabGroup.selectedIndex = this.ORDERS_TAB;
                this.activeTabIndex = 1;
                this.ready = true;
            }, 2000);
        } else {
            this.route.queryParams.subscribe((queryParams) => {
                if (queryParams['tab'] === 'ai-billing' && this.tabGroup) {
                    setTimeout(() => {
                        this.activeTabIndex = 2;
                        this.tabGroup.selectedIndex = 2;
                        this.ready = true;
                    }, 1000);
                }
            });
        }
    }

    // initForm() {
    //     this.form = this.formBuilder.group({
    //         'enterpriseUsername': [''],
    //         'status': [''],
    //         'password': [''],
    //         'confirmPassword': ['']
    //     }, {validator: equalValueValidator('password', 'confirmPassword')});
    // }

    selectAvatar(files: FileList): void {
        const file: File | undefined = files[0];
        this.avatarFile = file;
        this.uploaded = false;
        if (file) {
            const reader = new FileReader();
            /**
             * Is there a better solution?
             * @see https://github.com/Microsoft/TypeScript/issues/299#issuecomment-168538829
             */
            reader.onload = (e: Event) => {
                this.avatarSrc = e.target['result'];
            };
            reader.readAsDataURL(file);
            this.avatarTooSmall = file.size < 100;
            this.avatarTooLarge = file.size > 1024 * 200;
        } else {
            this.avatarSrc = undefined;
            this.avatarTooSmall = false;
            this.avatarTooLarge = false;
        }
    }

    onChangeUserName() {

    }

    updateAvatar(): void {
        // this.userStore.updateAvatar(this.model, this.avatarFile)
        //   .subscribe((data: ResponseData) => {
        //     if (dataIsSuccess(data)) {
        //       this.authUserService.replace({
        //         ...this.model,
        //         ...data.data
        //       });
        //       this.uploaded = true;
        //       this.showMessage('Avatar update successful!');
        //     }
        //   }, (errorResp: HttpErrorResponse) => {
        //     if (errorResp.status === 422) {
        //       const error: ErrorMessage | undefined = errorResp.error.data.find(
        //         (errorMessage: ErrorMessage) => errorMessage.field === 'avatarFile'
        //       );
        //       if (error) {
        //         this.showMessage(error.message);
        //       }
        //     }
        //   });
    }

    onRevealPassword() {
        this.dialog.open(this.revealPassword);
    }

    onTabChange(event: any) {
        this.activeTabIndex = event.index;
        // Clear the query params when user manually changes tabs
        this.router.navigate(['/orders']);
    }

    onChangeAvatar(event) {
        if (!event.value) return;
        this.localStoreService.setStorageValConfig('useAvatar', event.value);
    }

    get avatarInvalid(): boolean {
        return this.avatarTooSmall || this.avatarTooLarge;
    }

    submit(e: Event) {
        e.preventDefault();
    }

    getContent(order: IOrderForm) {
        const getDate = () => {
            const d = new Date(order.order_date ? order.order_date : order.order_date);
            return d.toLocaleDateString("en-US");
        };
        const getOrderId = () => {
            return order.payment_id ? order.payment_id : order.order_id;
        };
        const getOrderType = () => {
            return 'Order ';
        };
        // const paymentDate = getDate();
        const type = getOrderType();
        const orderId = getOrderId();
        return `${type} | ${orderId}`;
    }

    @Memoizee({})
    getId(): any {
        return (order: IOrderForm) => {
            return order.order_id ? order.order_id : order.payment_id;
        };
    }

    onSelection() {
        const order: IOrderForm = this.simplelist.getSelected().item;
        this.storeSelector.dispatch(actionLoadOrderRequest({
            orderId: String(order.order_id ? order.order_id : order.payment_id)
        }));
        // var accountType = this.appStore.getState().appdb.get('accountType');
        // _.forEach(orderSelected, (order: IsimplelistItem) => {
        //     if (order.selected) {
        //         this.appStore.dispatch(this.ordersAction.fetchOrder(order.item.getOrderId(), accountType));
        //         return;
        //     }
        // });
    }
}
